// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Loading_overlay__FZEkZ","show":"Loading_show__zMzIe","loading":"Loading_loading__vZLea"};